import PremiumBblEditor from './components/PremiumBblEditor.vue'
import PremiumBblEditorOptionsAPI from './components/PremiumBblEditorOptionsAPI.vue'
import DiagnosticTool from './components/DiagnosticTool.vue'
import DebugHelper from './components/DebugHelper.vue'
import { useEditor } from './composables/useEditor.js'

// Import all components for individual use
import ToolbarMain from './components/Toolbar/ToolbarMain.vue'
import ToolbarGroup from './components/Toolbar/ToolbarGroup.vue'
import ToolbarButton from './components/Toolbar/ToolbarButton.vue'
import EditorBubbleMenu from './components/Menus/BubbleMenu.vue'
import TableBubbleMenu from './components/Menus/TableBubbleMenu.vue'
import ImageBubbleMenu from './components/Menus/ImageBubbleMenu.vue'
import VideoBubbleMenu from './components/Menus/VideoBubbleMenu.vue'
import ImageModal from './components/Modals/ImageModal.vue'
import VideoModal from './components/Modals/VideoModal.vue'
import LinkModal from './components/Modals/LinkModal.vue'

// Import extensions
import ResizableImage from './extensions/ResizableImage.js'
import ResizableVideo from './extensions/ResizableVideo.js'
import CustomTableCell from './extensions/CustomTableCell.js'
import CustomTableHeader from './extensions/CustomTableHeader.js'

// Import styles
import './styles/editor.css'
import './styles/toolbar.css'
import './styles/tables.css'

// Individual component exports
export {
  PremiumBblEditor,
  PremiumBblEditorOptionsAPI,
  DiagnosticTool,
  DebugHelper,
  ToolbarMain,
  ToolbarGroup,
  ToolbarButton,
  EditorBubbleMenu,
  TableBubbleMenu,
  ImageBubbleMenu,
  VideoBubbleMenu,
  ImageModal,
  VideoModal,
  LinkModal,
  ResizableImage,
  ResizableVideo,
  CustomTableCell,
  CustomTableHeader,
  useEditor
}

// Vue plugin install function
const install = (Vue, options = {}) => {
  // Register the main component globally
  Vue.component('PremiumBblEditor', PremiumBblEditor)
  Vue.component('PremiumBblEditorOptionsAPI', PremiumBblEditorOptionsAPI)
  Vue.component('DiagnosticTool', DiagnosticTool)
  Vue.component('DebugHelper', DebugHelper)
  
  // Optionally register other components if requested
  if (options.registerAllComponents) {
    Vue.component('ToolbarMain', ToolbarMain)
    Vue.component('ToolbarGroup', ToolbarGroup)
    Vue.component('ToolbarButton', ToolbarButton)
    Vue.component('EditorBubbleMenu', EditorBubbleMenu)
    Vue.component('TableBubbleMenu', TableBubbleMenu)
    Vue.component('ImageBubbleMenu', ImageBubbleMenu)
    Vue.component('VideoBubbleMenu', VideoBubbleMenu)
    Vue.component('ImageModal', ImageModal)
    Vue.component('VideoModal', VideoModal)
    Vue.component('LinkModal', LinkModal)
  }
}

// Auto-install when Vue is found (in browser via script tag)
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

// Default export for Vue plugin
export default {
  install,
  PremiumBblEditor,
  PremiumBblEditorOptionsAPI,
  DiagnosticTool,
  DebugHelper
}